// import { dialog, InputFactory } from "../../../../nq-component";
// import React, { useState } from "react";

// function DialogHired({ handleSubmit, object }) {
//   const [endDate, setEndDate] = useState("");
//   const [employmentStatus, setStatus] = useState("");
//   const [department, setDepartment] = useState("");

//   function _handleAssign() {
//     handleSubmit(endDate, employmentStatus, department);
//   }
//   console.log(endDate);
//   return (
//     <>
//       <form
//         onSubmit={(e) => {
//           e.preventDefault();
//           _handleAssign();
//         }}
//       >
//         <div className="p-4">
//           <div className="d-flex flex-column">
//             <div className="d-flex gap-3">
//               <i
//                 class="bi bi-briefcase fs-2 px-2 py-1 rounded"
//                 style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
//               ></i>
//               <h5
//                 className="fw-bold align-self-center"
//                 style={{ color: "#D18237" }}
//               >
//                 Hire Applicant
//               </h5>
//             </div>
//             <div className="d-flex flex-column mx-5 mt-4">
//               <div className="">
//                 <div className="mb-3">
//                   <p className="m-0">
//                     Employment Status <span className="text-danger">*</span>
//                   </p>
//                   <InputFactory
//                     type="Enum"
//                     required
//                     options={[
//                       "Regular",
//                       "Probationary",
//                       "Seasonal",
//                       "Project Based",
//                     ]}
//                     onChange={(value) => setStatus(value)}
//                     className="m-0"
//                     placeholder="Select Employment Status"
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <p className="m-0">
//                     Department <span className="text-danger">*</span>
//                   </p>
//                   <InputFactory
//                     type="Enum"
//                     required
//                     options={[
//                       "Food and Beverage Division",
//                       "Kitchen Division",
//                       "Housekeeping Division",
//                       "Skilled and Admin Division",
//                     ]}
//                     onChange={(value) => setDepartment(value)}
//                     className="m-0"
//                     placeholder="Select Department"
//                   />
//                 </div>
//                 {employmentStatus === "Seasonal" ||
//                 employmentStatus === "Project Based" ? (
//                   <div className="mb-3">
//                     <p className="m-0">
//                       End Date <span className="text-danger">*</span>
//                     </p>
//                     <input
//                       type="date"
//                       value={endDate}
//                       onChange={(e) => setEndDate(e.target.value)}
//                       className="col-12 px-3 py-2 border rounded"
//                       min={
//                         object?.startDate
//                           ? new Date(new Date(object.startDate).getTime())
//                               .toISOString()
//                               .split("T")[0]
//                           : undefined
//                       }
//                       required
//                     />
//                   </div>
//                 ) : (
//                   ""
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="text-center mb-3">
//           <>
//             <>
//               <button
//                 className="btn"
//                 style={{ backgroundColor: "#e8ecf3" }}
//                 onClick={() => dialog.close()}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="btn text-white ms-2"
//                 style={{ backgroundColor: "#D18237" }}
//                 // onClick={() => _handleAssign()}
//               >
//                 Confirm
//               </button>
//             </>
//           </>
//         </div>
//       </form>
//     </>
//   );
// }

// export default DialogHired;

import { dialog, InputFactory } from "../../../../nq-component";
import React, { useState } from "react";

function DialogHired({ handleSubmit, object }) {
  const [endDate, setEndDate] = useState("");
  const [employmentStatus, setStatus] = useState("");
  const [department, setDepartment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function _handleAssign() {
    if (isSubmitting) return;

    try {
      setIsSubmitting(true);
      await handleSubmit(endDate, employmentStatus, department);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        await _handleAssign();
      }}
    >
      <div className="p-4">
        <div className="d-flex flex-column">
          <div className="d-flex gap-3">
            <i
              className="bi bi-briefcase fs-2 px-2 py-1 rounded"
              style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
            ></i>
            <h5
              className="fw-bold align-self-center"
              style={{ color: "#D18237" }}
            >
              Hire Applicant
            </h5>
          </div>

          <div className="d-flex flex-column mx-5 mt-4">
            <div className="mb-3">
              <p className="m-0">
                Employment Status <span className="text-danger">*</span>
              </p>
              <InputFactory
                type="Enum"
                required
                options={[
                  "Regular",
                  "Probationary",
                  "Seasonal",
                  "Project Based",
                ]}
                onChange={(value) => setStatus(value)}
                className="m-0"
                placeholder="Select Employment Status"
                disabled={isSubmitting}
              />
            </div>

            <div className="mb-3">
              <p className="m-0">
                Department <span className="text-danger">*</span>
              </p>
              <InputFactory
                type="Enum"
                required
                options={[
                  "Food and Beverage Division",
                  "Kitchen Division",
                  "Housekeeping Division",
                  "Skilled and Admin Division",
                ]}
                onChange={(value) => setDepartment(value)}
                className="m-0"
                placeholder="Select Department"
                disabled={isSubmitting}
              />
            </div>

            {(employmentStatus === "Seasonal" ||
              employmentStatus === "Project Based") && (
              <div className="mb-3">
                <p className="m-0">
                  End Date <span className="text-danger">*</span>
                </p>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="col-12 px-3 py-2 border rounded"
                  min={
                    object?.startDate
                      ? new Date(new Date(object.startDate).getTime())
                          .toISOString()
                          .split("T")[0]
                      : undefined
                  }
                  required
                  disabled={isSubmitting}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="text-center mb-3">
        <button
          type="button"
          className="btn"
          style={{ backgroundColor: "#e8ecf3" }}
          onClick={() => dialog.close()}
          disabled={isSubmitting}
        >
          Cancel
        </button>

        <button
          type="submit"
          className="btn text-white ms-2"
          style={{ backgroundColor: "#D18237", minWidth: "120px" }}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Loading...
            </>
          ) : (
            "Confirm"
          )}
        </button>
      </div>
    </form>
  );
}

export default DialogHired;
